"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var semantic_ui_react_1 = require("semantic-ui-react");

var component_1 = require("..");

var data_1 = require("../../data");

var SettingsPanel =
/** @class */
function (_super) {
  __extends(SettingsPanel, _super);

  function SettingsPanel(props) {
    var _this = _super.call(this, props) || this;

    _this.panel = null;

    _this.onButtonClick = function (e) {
      _this.setState({
        visible: !_this.state.visible
      });
    };

    _this.renderSettingsButton = function () {
      return React.createElement(semantic_ui_react_1.Button, {
        basic: true,
        floated: 'right',
        icon: 'settings',
        onClick: _this.onButtonClick
      });
    };

    _this.state = {
      visible: false
    };
    return _this;
  }

  SettingsPanel.prototype.componentDidUpdate = function (prevProps, prevState) {
    var _this = this;

    var visible = this.state.visible;

    if (visible && prevState.visible !== visible) {
      window.addEventListener('click', function (e) {
        if (_this.panel) {
          var panelRect = _this.panel.getBoundingClientRect();

          var x = e.x,
              y = e.y;
          var isIntersected = x >= panelRect.left && x <= panelRect.right && y >= panelRect.top && y <= panelRect.bottom;

          if (!isIntersected) {
            _this.hideSettingsPanel();

            window.removeEventListener('click', _this.hideSettingsPanel);
          }
        }
      });
    } else {
      window.removeEventListener('click', function (e) {
        return _this.hideSettingsPanel;
      });
    }
  };

  SettingsPanel.prototype.render = function () {
    var _this = this;

    var _a = this.props,
        children = _a.children,
        configurations = _a.configurations,
        inverted = _a.inverted,
        opacity = _a.opacity,
        showConfigurations = _a.showConfigurations,
        width = _a.width;
    var visible = this.state.visible;
    return React.createElement("div", {
      ref: function ref(node) {
        return _this.panel = node ? node : null;
      }
    }, React.createElement(semantic_ui_react_1.Grid, {
      columns: 1
    }, showConfigurations && React.createElement(semantic_ui_react_1.Grid.Column, null, this.renderSettingsButton()), React.createElement(semantic_ui_react_1.Sidebar.Pushable, {
      style: {
        width: width
      }
    }, React.createElement(semantic_ui_react_1.Sidebar, {
      as: semantic_ui_react_1.Menu,
      animation: 'overlay',
      inverted: inverted,
      style: {
        width: width,
        opacity: opacity
      },
      vertical: true,
      visible: visible
    }, this.renderConfigurations(configurations)), React.createElement(semantic_ui_react_1.Sidebar.Pusher, null, children))));
  };

  SettingsPanel.prototype.renderConfigurations = function (configurations) {
    var _this = this;

    return React.createElement(semantic_ui_react_1.Grid, {
      centered: true
    }, configurations.map(function (config, index) {
      var id = config.id ? config.id : config.name.toLowerCase().split(' ').join('-') + "-" + index;

      switch (config.type) {
        case data_1.CONFIGURATION_COMPONENT_TYPE.BUTTON:
          return React.createElement(semantic_ui_react_1.Grid.Row, {
            key: id
          }, _this.renderConfigurationButton(config, id));

        case data_1.CONFIGURATION_COMPONENT_TYPE.LABEL:
          return React.createElement(semantic_ui_react_1.Grid.Row, {
            key: id
          }, _this.renderConfigurationLabel(config, id));

        case data_1.CONFIGURATION_COMPONENT_TYPE.RADIO:
          return React.createElement(semantic_ui_react_1.Grid.Row, {
            key: id
          }, _this.renderConfigurationRadioButton(config, id));

        case data_1.CONFIGURATION_COMPONENT_TYPE.SLIDER:
          return React.createElement(semantic_ui_react_1.Grid.Row, {
            key: id
          }, _this.renderConfigurationSlider(config, id));

        default:
          {
            return React.createElement(semantic_ui_react_1.Grid.Row, {
              key: id
            }, "configuration for " + id);
          }
      }
    }));
  };

  SettingsPanel.prototype.renderConfigurationButton = function (config, id) {
    return React.createElement(semantic_ui_react_1.Button, {
      compact: true,
      id: id,
      onClick: config.onClick,
      style: __assign({}, config.style)
    }, config.icon && React.createElement(semantic_ui_react_1.Icon, {
      name: config.icon
    }), config.name);
  };

  SettingsPanel.prototype.renderConfigurationLabel = function (config, id) {
    return React.createElement(semantic_ui_react_1.Label, {
      basic: true,
      id: id,
      style: __assign({}, config.style),
      color: 'orange'
    }, config.name);
  };

  SettingsPanel.prototype.renderConfigurationRadioButton = function (config, id) {
    return React.createElement(component_1.ChellRadioGroup, {
      id: id,
      options: config.options,
      onChange: config.onChange,
      style: __assign({
        color: 'white'
      }, config.style),
      title: config.name
    });
  };

  SettingsPanel.prototype.renderConfigurationSlider = function (config, id) {
    return React.createElement(component_1.ChellSlider, {
      className: id,
      label: config.name,
      max: config.values.max,
      min: config.values.min,
      onAfterChange: config.onAfterChange,
      onChange: config.onChange,
      style: __assign({
        color: 'white',
        padding: '0 25px',
        width: '95%'
      }, config.style),
      value: config.values.current
    });
  };

  SettingsPanel.prototype.hideSettingsPanel = function () {
    this.setState({
      visible: false
    });
  };

  SettingsPanel.defaultProps = {
    configurations: new Array(),
    direction: 'left',
    inverted: true,
    opacity: 0.6,
    showConfigurations: true,
    width: '100%'
  };
  return SettingsPanel;
}(React.Component);

exports.SettingsPanel = SettingsPanel;